export default "__VITE_ASSET__CzdUQ0EE__"